import { createGlobalStore } from '@aries/shared/deps';
import { useState } from 'react';
import { getProviderHub, useProviderHub } from '../common';
import {
  ARIES_MAINNET_MERKLE_POOL_PROGRAM_ADDRESS,
  ARIES_PROGRAM_ADDRESS,
  ARIES_TEST_PROGRAM_ADDRESS,
} from '../config';

type Market = {
  id: string;
  name: string;
  logo: string;
  profileNamePrefix: string;
  description?: string;
};

const MAINNET_MARKETS: Market[] = [
  {
    id: ARIES_PROGRAM_ADDRESS,
    name: 'Main Pool',
    logo: 'https://assets.panora.exchange/tokens/aptos/APT.svg',
    profileNamePrefix: '',
    description: `Main Pool is Aries's flagship pool, which has the highest bar for quality asset listings and risk management.`,
  },
  {
    id: ARIES_MAINNET_MERKLE_POOL_PROGRAM_ADDRESS,
    name: 'Merkle LP Pool',
    logo: 'https://assets.panora.exchange/tokens/aptos/MKLP.png',
    profileNamePrefix: 'turbo_',
  },
];

const TESTNET_MARKETS: Market[] = [
  {
    id: ARIES_TEST_PROGRAM_ADDRESS,
    name: 'Main Pool',
    logo: 'https://assets.panora.exchange/tokens/aptos/APT.svg',
    profileNamePrefix: '',
    description: `Main Pool is Aries's flagship pool, which has the highest bar for quality asset listings and risk management.`,
  },
];

export const [useLendingMarkets, getLendingMarkets] = createGlobalStore(
  () => {
    const { env } = useProviderHub();

    const markets = env.isMainnet ? MAINNET_MARKETS : TESTNET_MARKETS;

    const [activeMarketId, setActiveMarket] = useState(markets[0].id);

    const acitiveMarket =
      markets.find(_m => _m.id === activeMarketId) || markets[0];

    return {
      markets,
      activeMarketId: acitiveMarket.id,
      activeProfileNamePrefix: acitiveMarket.profileNamePrefix,
      setActiveMarket,
    };
  },
);

export const getAriesProgram = () => getLendingMarkets()?.activeMarketId!;

export const getAriesMainPoolProgram = () =>
  getProviderHub()?.env.isMainnet
    ? ARIES_PROGRAM_ADDRESS
    : ARIES_TEST_PROGRAM_ADDRESS;
